module.exports = __webpack_public_path__ + "img/typo-02.888e0907.png";